"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var layouts_1 = require("../../controls/layouts");
wp.customize.controlConstructor['epsilon-layouts'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new layouts_1.EpsilonLayouts(control);
        /**
         * Save layout
         */
        control.container.on('change', 'input', function (e) {
            control.setting.set(jQuery(e.target).val());
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/layouts.ts
// module id = 19
// module chunks = 0